<template>
    <div v-if="!isLoading" class="blogs-page wrapper">
      <div class="columns is-tablet">
          <div class="column is-9-tablet is-12-mobile is-9-widescreen is-9-fullhd">
            <back-button class="mb-5"/>
            <div class="p-b-100" v-if="blogdata">
            <h1 class="title-page is-size-5 is-size-4-desktop has-text-weight-bold">Blog</h1>
            <div class=" mb-4">
              <div class="dropdown" :class="{ 'is-active': dropdownActive }">
                  <div class="dropdown-trigger">
                      <input
                      type="text"
                      class="input input-search"
                      placeholder="Search"
                      v-model="searchQuery"
                      @focus="toggleDropdown(true)"
                      @blur="toggleDropdown(false)"
                      @input="onInput"
                      />
                  </div>
                  <!-- Dropdown Menu -->
                  <div class="dropdown-menu" role="menu">
                      <div class="dropdown-content">
                      <!-- Filtered Items -->
                      <a
                          v-for="(item, index) in filteredItems"
                          :key="index"
                          class="dropdown-item"
                          target="_blank"
                          @mousedown.prevent="selectItem(item)"
                      >
                          {{ item.title }}
                      </a>
                      <!-- No Items Found -->
                      <div v-if="filteredItems.length === 0" class="dropdown-item">
                          No items found.
                      </div>
                      </div>
                  </div>
              </div>
            </div>
                <div class="columns is-flex-direction-column">
                  <div class="column is-full-mobile " v-for="(i, index) in blogdata.data" :key="index">
                      <blog-card :blog="i"></blog-card>
                  </div>
                </div>
                <div class="mt-2">
                  <span v-if="!isHiddenViewMore" @click="viewMoreBlogs" class="btn btn-clear">View more</span>
                </div>
                <div class="preloadmore-center" v-show="isLoadMore">
                    <Preloader />
                </div>
                <div class="columns">
                  <div class="column disclaimer">
                      <Disclaimer />
                  </div>
                </div>
            </div>
            <div v-if="isBannerMobile" class="column is-12-mobile is-3-widescreen banner-home is-hidden-tablet">
              <div class="banner-on-top" ref="subRight">
                <AdsGoogle /> 
              </div>
            </div>
          </div>
          <div v-if="!isBannerMobile" ref="subRight_before" class="column is-12-mobile is-3-widescreen is-hidden-mobile">
            <div class="banner-on-top" ref="subRight">
              <AdsGoogle /> 
            </div>
          </div>
      </div>
    </div>
    <div class="preloader-center" v-else>
        <Preloader />
    </div>
</template>
<script>
import axios from "axios";
import commonMixin from "@/mixins/commonMixin";
import bannerMixin from "@/mixins/bannerMixin";
import Preloader from "@/components/Preloader";
import BackButton from "@/components/BackButton";
import Disclaimer from "@/components/Disclaimer";
import BlogCard from '../components/BlogCard.vue';
import AdsGoogle from '@/components/AdsGoogle.vue';

export default {
    components: { BlogCard, Preloader, BackButton, Disclaimer, AdsGoogle },
    name: 'Blog',
    mixins: [commonMixin, bannerMixin],
    data: function () {
        return {
            blogdata:null,
            currentPage: 1,
            isLoading: false,
            previousPage: 0,
            isHiddenViewMore: true,
            isLoadMore: false,
            blogs: null,
            dropdownActive: false,
            searchQuery: "",
            filteredItems: [],
        }
    },
    mounted(){
        const isBackBtnResults = this.$store.state.search.isBackBtnResults;
        if (isBackBtnResults) {
            this.blogdata = this.$store.state.blog.blogData;
            this.currentPage = this.$store.state.blog.previousPage;
        } else {
            this.getPosts(this.currentPage, true);
        }
        this.getBlogs();
    },
    updated() {
        this.$store.commit("blog/SET_PREVIOUS_PAGE", 1);
        this.$store.commit('blog/SET_BLOG_DATA', false);
        this.$store.commit('search/SET_BACKBTN_RESULTS', false);
    },
    watch: {
        currentPage: function (val) {
            const isBackBtnResults = this.$store.state.search.isBackBtnResults;
            if (isBackBtnResults) {
                return;
            }
            this.getPosts(val);
        },
    },
    methods: {
        getPosts(currentPage, isLoadingPage = false) {
            this.isLoading = isLoadingPage;
            this.isLoadMore = true;
            axios.get("/blog", {params: {page: currentPage}}).then(response => {
                this.blogdata = {
                    ...response.data,
                    data: this.blogdata && this.blogdata.data ? [...this.blogdata.data, ...response.data.data] : response.data.data
                }
                if (this.currentPage === response.data.last_page) {
                    this.isHiddenViewMore = true;
                } else {
                    this.isHiddenViewMore = false;
                }
            }).finally(() => {
              this.isLoadMore = false;
              this.isLoading = false;
            })
        },
        viewMoreBlogs() {
          this.currentPage++;
        },
        getBlogs() {
          axios.get("/blog", {params: {limit: -1}}).then(response => {
            if (response)
              this.blogs = response.data
          })
        },
        toggleDropdown(state) {
          this.dropdownActive = state;
        },
        onInput() {
          const query = this.searchQuery.toLowerCase();
          if (query.trim() === '' ) {
              this.filteredItems = [];
          } else {
              this.filteredItems = this.blogs.data.filter((item) =>
                  item.title.toLowerCase().includes(query)
              );
          }
          
          if (!this.dropdownActive) this.toggleDropdown(true);
        },
        selectItem(item) {
          this.$router.push({ path:`/blog/${item.id}/${item.slug}`, params: { id: item.id } })
        }
    },
    metaInfo() {
        return {
            title: "Blog & Investment Ideas | Pickafund",
        }
    },
    created() {
        window.addEventListener('scroll', this.handleScroll);
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    beforeRouteLeave(to, from, next) {
      this.$store.commit('blog/SET_PREVIOUS_PAGE', this.currentPage);
      this.$store.commit('blog/SET_BLOG_DATA', this.blogdata);
      next();
    }
}
</script>
<style scoped lang="scss">
.title-page {
  padding-bottom: 0.75rem;
}
.preloadmore-center {
  height: auto;
  padding: 60px 20px 20px 20px;
}
.input-search {
    background-image: url(/img/search-icon.png);
    background-position: 8px center;
    background-repeat: no-repeat;
    padding-left: 1.75em;
    background-size: 21px;
}
</style>